import React from "react";
import { Link } from "react-router-dom";
import { Leaf, Home } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-paper flex flex-col">
      <Header />
      <main className="flex-1 mx-auto max-w-xl px-6 py-24 text-center flex flex-col items-center justify-center" data-testid="not-found">
        <div className="w-16 h-16 rounded-full bg-brandter flex items-center justify-center mb-5">
          <Leaf className="text-brand" size={30} />
        </div>
        <p className="font-display text-7xl text-ink leading-none">404</p>
        <h1 className="font-display text-3xl text-ink mt-3">Page not found</h1>
        <p className="text-muted2 mt-2">The page you're looking for doesn't exist or has moved.</p>
        <Link to="/" className="mt-7 inline-flex items-center gap-2 bg-brand text-white font-semibold rounded-full px-7 h-12 hover:bg-brandsec transition-colors" data-testid="not-found-home">
          <Home size={18} /> Back to store
        </Link>
      </main>
      <Footer />
    </div>
  );
}
